import { MixerHorizontalIcon } from "@radix-ui/react-icons";

import { Button } from "src/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";

const DataTableViewSettings = ({
  options,
  isColumns,
  onOptionChange,
  onReset,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xs" className="p-1">
          <MixerHorizontalIcon className="text-muted-foreground size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[150px]">
        <DropdownMenuLabel>
          Toggle {isColumns ? "columns" : "rows"}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          {options.map((option) => {
            return (
              <DropdownMenuCheckboxItem
                key={option.name}
                checked={option.value}
                onCheckedChange={(value) => {
                  onOptionChange(option, value);
                }}
                onSelect={(e) => {
                  e.preventDefault();
                }}
              >
                {option.name}
              </DropdownMenuCheckboxItem>
            );
          })}
        </DropdownMenuGroup>

        {onReset && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuCheckboxItem
                onSelect={(e) => {
                  e.preventDefault();
                  onReset();
                }}
              >
                Reset to default
              </DropdownMenuCheckboxItem>
            </DropdownMenuGroup>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DataTableViewSettings;
